module.exports = __webpack_public_path__ + "img/Malaysia.f5182b3f.gif";